import { documentSearchEngine } from './documentSearchEngine';
import background from './portalGates/toBackground';

export async function clearAllLocalData(shouldReloadApplication = true) {
  await background.clearAllLocalData(shouldReloadApplication);
}

export async function clearSearchAndContent() {
  await background.clearAllDocumentContentStores();
  await documentSearchEngine.destroy();
}
